import { render, staticRenderFns } from "./MaterialItemTable.vue?vue&type=template&id=866c7a34&"
import script from "./MaterialItemTable.vue?vue&type=script&lang=ts&"
export * from "./MaterialItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports